import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import { CustomBook } from '../../../components/Book/Book';
import ClubImage from '../../../components/ClubImage/ClubImage';
import DefaultContainer from '../../../components/DefaultContainer/DefaultContainer';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import Icon from '../../../components/Icon/Icon';
import { getClub } from '../../../service/clubs';
import { deleteVote, getCandidatesByElectionId, getElection, getElectionsByUserId, getElectionResult, getUserVoteByUserAndElectionId, insertVote } from '../../../service/election';
import { createErrorNotification, createSuccessNotification } from '../../../service/notification';
import { useUserStore } from '../../../store/useUser';
import { button_color, main_color_50 } from '../../../styles/_variables';
import { getFormattedClubName } from '../../../utils/club';

import styles from './Candidates.module.scss';
import useHeader from '../../../hooks/useHeader';

const CandidateBook = () => {
  const location = useLocation();

  const userId = useUserStore(state => state.id)

  useHeader({ header: getFormattedClubName(), subheader: 'Cadastro de Votação' });

  const path = location.pathname.split('/')
  const electionId = path[4]

  const {data:ballotBox, isFetching, refetch } = useQuery(
    ['ballotBox', electionId],
    () => getUserVoteByUserAndElectionId(userId, Number(electionId)),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const {data:candidates, isFetching: isFetchingCandidates} = useQuery(
    ['candidates', electionId],
    () => getCandidatesByElectionId(Number(electionId)),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const {data:election} = useQuery(
    ['election', electionId],
    () => getElection(Number(electionId)),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  const finalDate = election?.finalDate;

  const electionIsFinish = new Date(finalDate) < new Date() || false


  const {data:result} = useQuery(
    ['result', Number(electionId)],
    () => getElectionResult(Number(electionId)),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled:electionIsFinish},
  );

  return (
    <div className={styles.container}>
      <HeaderPage bageColor={main_color_50} header='Candidatos'/>
      {electionIsFinish && <DefaultContainer>Proximo livro já decidido!</DefaultContainer>}
      {candidates?.map((candidate, index) => 
          <section className={`${styles.bookCandidateContainer} ${result && result[0]?.candidateId === candidate.id && styles.winner}` }>
            <div className={styles.candidateHeader}>
              <div>Livro {index + 1}</div>
              <div className={styles.candidateVotes}>{candidate.votes} votos</div>
            </div>
            <CustomBook bookId={Number(candidate.candidate)}/>
            { ballotBox?.candidateId === candidate.id &&  
                <Check 
                  electionIsFinish={electionIsFinish}
                  refetch={refetch} candidate={candidate?.id}/> 
            } 
            { !ballotBox?.id && 
                  <BallotBox
                    electionIsFinish={electionIsFinish}
                    refetch={refetch} 
                    candidate={candidate?.id}/>
            }
          </section>
      )}
      {!candidates?.length && !isFetchingCandidates 
        ? "Ops, parece que está vazio." : null}
    </div>
  )
}

export const Check = ({candidate, refetch, electionIsFinish}) => {
  const location = useLocation();
  const profile = useUserStore(state => state.profile)

  const path = location.pathname.split('/')
  const electionId: number = Number(path[4]);

  const userId = useUserStore(state => state.id)

  if(profile === 'Criador' || profile === 'Mediador' ) return null;

  const handleClick = async () => {
    if(electionIsFinish) return;

    const {error: hasError , success} = await deleteVote(electionId, userId, candidate)
    //isError

    if(hasError) {
      return createErrorNotification('Algo deu errado, tente novamente')
    }

    refetch()

    createSuccessNotification('Excluido!');
  }

  return (
    <div className={styles.check} onClick={handleClick}>
      <Icon icon='check' color={button_color} />
        Votado
      </div>
  )
}

export const BallotBox = ({candidate, refetch, electionIsFinish}) => {
  const location = useLocation();

  const path = location.pathname.split('/')
  const profile = useUserStore(state => state.profile)

  const electionId = path[4]

  const userId = useUserStore(state => state.id)

  if(electionIsFinish) return null;

  if(profile === 'Criador' || profile === 'Mediador' ) return null;


  const handleClick = async () => {
    const {error, success} = await insertVote(Number(electionId), userId, candidate)

    if(error) {
      return createErrorNotification('Algo deu errado, tente novamente')
    }

    refetch()
    createSuccessNotification('Votado!');
  }

  return (
    <div className={styles.check} onClick={handleClick}>
      <Icon icon='ballotbox' color={button_color} />
        Votar
    </div>
  )
}


export const Club = ({clubId}) => {
  const {data:club, isFetching} = useQuery(
    ['club', clubId],
    () => getClub(clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  return (
      <div >
        <header className={styles.clubHeader}>
          <ClubImage clubName={club?.name} path={club?.pathPhoto}/>
        <strong>{club?.name}</strong>
      </header>
    </div>
  )
}

export default CandidateBook;